import React from "react";
import FollowInvoiceContent from "../../Component/FollowInvoice/FollowInvoiceContent";
import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";

function FollowInvoice() {
  return (
    <div className="apDiv Roles">
      <Sidebar />
      <div className="body_container container" dir="rtl">
        <div className="Header">
          <Header />
        </div>
        <FollowInvoiceContent />
      </div>
    </div>
  );
}

export default FollowInvoice;
